﻿import { eShadowFilter, eShadowQuality, eShadowResolution } from '../enums';
import { IShadowLightNode } from '../kb3d-models';
import { LightNode } from './light-node';

export abstract class ShadowLightNode extends LightNode implements IShadowLightNode {
    constructor() {
        super();
    }

    public generatesShadows: boolean;
    public shadowQuality: eShadowQuality;
    public shadowResolution: eShadowResolution;
    public shadowFilter: eShadowFilter;
    public processTransparency: boolean;
}
